﻿const statusDefinitions = {
    notStarted: {
        color: '#ef3f6b',
        statusCopy: 'Ej påbörjad',
        buttonCopy: 'Fyll i hälsoprövning'

    },
    started: {
        color: '#f57f2f',
        statusCopy: 'Påbörjad',
        buttonCopy: 'Slutför'
    },
    pending: {
        color: '#00873F;',
        statusCopy: 'Under granskning'
        // no button
    }
}

const getRegistrationStatus = (registration) => {
    let status = 'notStarted';

    if (registration.hasDraft) {
        status = 'started';
    }
        
    if(registration.markedForRisk) {
        status = 'pending';
    }

    return status;
}

export {getRegistrationStatus, statusDefinitions};
